import { useEffect, useState } from 'react';

export const EnvCheck = () => {
  const [missingVars, setMissingVars] = useState<string[]>([]);

  useEffect(() => {
    const required = [
      'VITE_SUPABASE_URL',
      'VITE_SUPABASE_ANON_KEY', 
      'VITE_CLERK_PUBLISHABLE_KEY'
    ];

    const missing = required.filter(key => {
      const value = import.meta.env[key];
      return !value || value.includes('your-') || value.includes('https://your-');
    });

    setMissingVars(missing);
  }, []);

  if (missingVars.length === 0) return null;

  return (
    <div className="fixed inset-0 bg-background flex items-center justify-center p-4 z-50">
      <div className="bg-card border border-border rounded-lg p-6 max-w-md w-full">
        <h2 className="text-xl font-semibold mb-4">Configuration Required</h2>
        <p className="text-muted-foreground mb-4">
          The following environment variables need to be configured:
        </p>
        <ul className="list-disc list-inside space-y-2 mb-4">
          {missingVars.map(key => (
            <li key={key} className="font-mono text-sm">{key}</li>
          ))}
        </ul>
        <p className="text-sm text-muted-foreground">
          Please add these to your Netlify environment variables in the dashboard.
        </p>
      </div>
    </div>
  );
};
